


















































import Vue from 'vue';
    import Component from 'vue-class-component';
    import { UserService } from '@/services/UserService';
    import FileSaver, { saveAs } from 'file-saver';
@Component({})
export default class Download extends Vue {

    private loaderProgess: boolean = true;
    private loadingDone: boolean = false;
    private downloadError: boolean = false;
    private userService: UserService = new UserService();

    async mounted() {
        this.userService.getSigningSofware().then(success => {
            if (success.status == 400) {
                this.loadingDone = true;
                this.downloadError = true;
            }
            else {
                var filename = '';
                var disposition = success.headers.get('Content-Disposition');
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
                success.blob().then((b: any) => {
                    FileSaver.saveAs(b, decodeURIComponent(filename));
                })
            }
            console.log(success);
        })
            .catch(error => {
                this.loadingDone = true;
                this.downloadError = true;
            }).finally(() => {
                this.loadingDone = true;
            });
    }
}
